import type { AutomationRequestFrequency, AutomationRequestStatus } from '@adweb/shared';

export interface AutomationRequestRow {
  id: string;
  organizationId: string;
  title: string;
  description: string;
  /** Absente pour une demande née d'une suggestion. */
  frequency: AutomationRequestFrequency | null;
  tools: string | null;
  status: AutomationRequestStatus;
  adwebComment: string | null;
  createdAt: string;
  updatedAt: string;
  organization: { id: string; name: string };
  requestedBy: { id: string; fullName: string; email: string } | null;
  /** Suggestion d'Adweb-Systèmes à l'origine de la demande. */
  suggestion: { id: string; title: string } | null;
  /** Présents dans la liste uniquement. */
  lastMessage?: Pick<RequestMessage, 'body' | 'fromAdweb' | 'statusChange'> | null;
  messageCount?: number;
  /** Message de l'autre côté pas encore lu. */
  unread?: boolean;
}

export interface RequestMessage {
  id: string;
  body: string;
  fromAdweb: boolean;
  statusChange: AutomationRequestStatus | null;
  createdAt: string;
  author: { id: string; fullName: string } | null;
}

export const STATUS_ORDER: AutomationRequestStatus[] = [
  'NEW',
  'IN_REVIEW',
  'PLANNED',
  'DONE',
  'DECLINED',
];

export const STATUS_META: Record<AutomationRequestStatus, { label: string; cls: string }> = {
  NEW: { label: 'Nouvelle', cls: 'bg-blue-100 text-blue-800' },
  IN_REVIEW: { label: 'À l’étude', cls: 'bg-amber-100 text-amber-800' },
  PLANNED: { label: 'Planifiée', cls: 'bg-violet-100 text-violet-800' },
  DONE: { label: 'Réalisée', cls: 'bg-emerald-100 text-emerald-800' },
  DECLINED: { label: 'Non retenue', cls: 'bg-slate-100 text-slate-600' },
};

export const FREQUENCY_OPTIONS: Array<{ value: AutomationRequestFrequency; label: string }> = [
  { value: 'ONCE', label: 'Ponctuelle' },
  { value: 'DAILY', label: 'Tous les jours' },
  { value: 'WEEKLY', label: 'Toutes les semaines' },
  { value: 'MONTHLY', label: 'Tous les mois' },
  { value: 'ON_EVENT', label: 'À chaque événement (e-mail, formulaire…)' },
];

export function frequencyLabel(value: AutomationRequestFrequency | null): string {
  if (!value) return '—';
  return FREQUENCY_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
